import React from 'react';
import { Button } from 'reactstrap';

const GenerateReportButton = React.memo(({
    isLoading,
    isDisabled,
    onClick
}) => (
    <Button
        color="success"
        onClick={onClick}
        disabled={isDisabled}
        className="w-100"
        style={{ height: '40px', fontSize: '14px' }}
    >
        {isLoading ? (
            <>
                <span className="spinner-border spinner-border-sm me-2"></span>&nbsp;
                İşleniyor...
            </>
        ) : (
            <>
                <i className="fa fa-file-excel-o mr-2"></i>
                Raporla
            </>
        )}
    </Button>
));

export default GenerateReportButton; 